// ═══════════════════════════════════════════════════════════════════════
// TRACKING READINESS — no fake IDs are shipped anywhere.
//
// 1. META PIXEL / GOOGLE TAG MANAGER / GOOGLE ANALYTICS:
//    Paste the real snippets in frontend/public/index.html where the
//    "TRACKING — ADD REAL IDS LATER" comment sits.
//
// 2. CUSTOM CONVERSION EVENTS:
//    Call fireConversion("eventName", { ...payload }) from any component
//    (e.g. after the GHL survey submit message) — it fans out to GTM's
//    dataLayer and Meta's fbq when they exist.
//
// 3. POST-SUBMIT REDIRECT LOGIC:
//    Configure inside GoHighLevel (survey settings → redirect). This site
//    intentionally owns no lead data.
//
// 4. UTM HANDLING:
//    captureAttribution() runs once on load and preserves campaign params
//    so they can be appended to the GHL survey URL or redirect later.
// ═══════════════════════════════════════════════════════════════════════

const ATTRIBUTION_KEY = "7fcc_attribution";
const TRACKED_PARAMS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_term",
  "utm_content",
  "fbclid",
  "gclid",
  "ref",
];

export function captureAttribution() {
  if (typeof window === "undefined") return;
  try {
    const params = new URLSearchParams(window.location.search);
    const found = {};
    TRACKED_PARAMS.forEach((key) => {
      const value = params.get(key);
      if (value) found[key] = value;
    });
    if (Object.keys(found).length > 0) {
      sessionStorage.setItem(ATTRIBUTION_KEY, JSON.stringify(found));
    }
  } catch {
    /* storage unavailable — silently ignore */
  }
}

export function getAttribution() {
  try {
    const raw = sessionStorage.getItem(ATTRIBUTION_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
}

// Appends preserved attribution params onto any URL (e.g. the GHL survey
// link or post-submit redirect) without overwriting its own params.
export function withAttribution(url) {
  const attribution = getAttribution();
  if (!url || Object.keys(attribution).length === 0) return url;
  try {
    const parsed = new URL(url);
    Object.entries(attribution).forEach(([k, v]) => {
      if (!parsed.searchParams.has(k)) parsed.searchParams.set(k, v);
    });
    return parsed.toString();
  } catch {
    return url;
  }
}

export function fireConversion(name, payload = {}) {
  if (typeof window === "undefined") return;
  if (Array.isArray(window.dataLayer)) {
    window.dataLayer.push({ event: name, ...payload });
  }
  if (typeof window.fbq === "function") {
    window.fbq("trackCustom", name, payload);
  }
  if (typeof window.gtag === "function") {
    window.gtag("event", name, payload);
  }
}
